import {
  applyAllocateTickets,
  applyConfirmRoundResult,
  applyLockMarket,
  applyRestartGame,
  applyRevealRound,
  applySubmitPrices,
  applyUseCheck,
  applyUseSecret,
} from "./appliers";
import type { FishShopV2Action, FishShopV2State } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: FishShopV2State,
  action: FishShopV2Action,
): FishShopV2State {
  if (!validateAction(state, action).valid) {
    return state;
  }

  if (action.type === "AllocateTickets") {
    return applyAllocateTickets(state, action);
  }
  if (action.type === "LockMarket") {
    return applyLockMarket(state, action);
  }
  if (action.type === "SubmitPrices") {
    return applySubmitPrices(state, action);
  }
  if (action.type === "UseSecret") {
    return applyUseSecret(state, action);
  }
  if (action.type === "UseCheck") {
    return applyUseCheck(state, action);
  }
  if (action.type === "RevealRound") {
    return applyRevealRound(state, action);
  }
  if (action.type === "ConfirmRoundResult") {
    return applyConfirmRoundResult(state, action);
  }
  if (action.type === "RestartGame") {
    return applyRestartGame(state, action);
  }

  return state;
}
